import { Subject } from 'rxjs';
import { InjectionToken } from "@angular/core";

export const QRCODE_SCANER = new InjectionToken<IQRCodeScaner>('qr code scaner');

export interface IQRCodeScaner {
  enable(): void;
  disable(): void;
  isEnabled: boolean;
  start(): Subject<string>;
  stop(): void;
  /** Show/hide a "scanned, talking to the server" busy indicator over the scanner
   *  while a captured code is being verified. No-op if the scanner isn't active. */
  setBusy(busy: boolean): void;
}
